import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_FACILITY_HOLIDAY_LIST, GET_FACILITY_HOLIDAY_LIST_SUCCESS, GET_FACILITY_HOLIDAY_LIST_ERROR } from '../../actions';
import apiCall from '../../../apiCall';

function* getFacilityHolidayList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { facilityId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/golf-inventory/facility-holiday/listing?facilityId=${facilityId}`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_FACILITY_HOLIDAY_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_FACILITY_HOLIDAY_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_FACILITY_HOLIDAY_LIST_ERROR, payload: error });
  }
}

export function* watchGetFacilityHolidayList() {
  yield takeEvery(GET_FACILITY_HOLIDAY_LIST, getFacilityHolidayList);
}

function* getFacilityHolidayListSaga() {
  yield all([fork(watchGetFacilityHolidayList)]);
}

export default getFacilityHolidayListSaga;
